import { inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Observable } from 'rxjs';

export abstract class SdDialogService<TComponent, TData, TResult> {
  protected dialog = inject(MatDialog);

  constructor(private component: ComponentType<TComponent>) {}

  open(data: TData, config?: Partial<MatDialogConfig>): Observable<TResult> {
    return this.dialog.open(this.component, {
      data,
      backdropClass: 'sd-dialog-backdrop',
      panelClass: 'sd-dialog-panel',
      autoFocus: false,
      restoreFocus: false,
      ...config
    }).afterClosed();
  }
}
